var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66699 3C8.94313 3 9.16699 3.22386 9.16699 3.5V9.29289L11.3134 7.14645C11.5087 6.95118 11.8253 6.95118 12.0205 7.14645C12.2158 7.34171 12.2158 7.65829 12.0205 7.85355L9.02055 10.8536C8.82528 11.0488 8.5087 11.0488 8.31344 10.8536L5.31344 7.85355C5.11818 7.65829 5.11818 7.34171 5.31344 7.14645C5.5087 6.95118 5.82528 6.95118 6.02055 7.14645L8.16699 9.29289V3.5C8.16699 3.22386 8.39085 3 8.66699 3ZM3.66699 12.5C3.66699 12.2239 3.89085 12 4.16699 12H13.167C13.4431 12 13.667 12.2239 13.667 12.5C13.667 12.7761 13.4431 13 13.167 13H4.16699C3.89085 13 3.66699 12.7761 3.66699 12.5Z",
    fill: "#017E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.17a87f5a5d9d43afd39bc595bd6a9041.svg";
export { ForwardRef as ReactComponent };